export const featureAvailabilityQueryKeys = {
  GET_FEATURE_INFO: 'getFeatureInfo'
}

// Both options ultimately resolve to an organisation's subscription — what
// changes is whose: the organisation that owns the project currently open
// (which may not be the user's own, e.g. an external collaboration), or the
// user's own organisation, regardless of which project is on screen.
export const featureScopeOptions = {
  PROJECT_ORGANISATION: 'project',
  OWN_ORGANISATION: 'organisation'
}
